export const APP_VERSION: string = "e91d6ee";
